import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import ReservationApi from "api/reservationApi";
import { formatQueryParams } from "helpers/format";

export const getReservations = createAsyncThunk(
  "Reservations",
  async (params: any = {}) => {
    try {
      const response = await ReservationApi.reservations(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getReservationsApi = async (params: any = {}) => {
  try {
    const response = await ReservationApi.reservations(
      formatQueryParams(params)
    );
    return response;
  } catch (error) {
    return error;
  }
};
